import React from 'react';
import { Col, Layout, Row, Typography } from 'antd';
import { Input } from 'components';
import { isValidURL } from './utils';

export const Step3 = () => (
  <Layout className="team-registration__step-3">
    <Row>
      <Col>
        <Typography.Title className="step-name" level={4}>
          Social Media Links
        </Typography.Title>
      </Col>
    </Row>
    <Row gutter={8}>
      <Col sm={24} md={12}>
        <Input
          name="web_site"
          label="Web site"
          rules={[
            {
              validator: (_, value) => {
                if (!value || isValidURL(value)) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('Must be a valid URL'));
              },
            },
          ]}
        />
      </Col>
      <Col sm={24} md={12}>
        <Input name="twitter" label="X (Twitter)" />
      </Col>
    </Row>
    <Row gutter={8}>
      <Col sm={24} md={12}>
        <Input name="instagram" label="Instagram" />
      </Col>
      <Col sm={24} md={12}>
        <Input name="facebook" label="Facebook" />
      </Col>
    </Row>
  </Layout>
);
